import { createContext, useContext } from 'react';

export const ScrollableContext = createContext<HTMLElement | null>(null);

export const useScrollableContext = () => useContext(ScrollableContext);
